import { render, staticRenderFns } from "./RecetaNutricionales.vue?vue&type=template&id=756abfe3&"
import script from "./RecetaNutricionales.vue?vue&type=script&lang=js&"
export * from "./RecetaNutricionales.vue?vue&type=script&lang=js&"
import style0 from "./RecetaNutricionales.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports